import NextImage from "../../../NextImage";
import type { SignalCardAssetProps } from "./types";

/**
 * Figma 94103 信号卡统一头：16px 头像 + ticker。 Figma：94103:23155
 */
export const SignalCardAssetHeader: React.FC<SignalCardAssetProps> = ({
  assetLogo,
  assetSymbol,
}) => {
  return (
    <div className="flex h-4 items-center gap-1">
      <div className="relative size-4 shrink-0 overflow-hidden rounded-full border border-border_solid">
        <NextImage
          src={assetLogo ?? ""}
          alt={assetSymbol}
          width={16}
          height={16}
          className="size-full object-cover"
        />
      </div>
      <span className="body_medium_s text-content_primary">{assetSymbol}</span>
    </div>
  );
};
